export default {
  "feedback_cate": {
    "HK": "反饋類型",
    "TW": "回饋類型",
    "ar_SA": "نوع الملاحظة",
    "de_DE": "Art des Feedbacks",
    "en_US": "Feedback Type",
    "es_ES": "Tipos de comentarios",
    "fr_FR": "Type de retour",
    "hi_IN": "Feedback Type",
    "in_ID": "Jenis Tanggapan",
    "ja_JP": "製品の提案",
    "ko_KR": "피드백 유형",
    "ms_MY": "Jenis Maklum Balas",
    "pt_PT": "Tipo de Comentário",
    "ru_RU": "Тип отзыва",
    "th_TH": "ประเภทฟีดแบ็ค",
    "tr_TR": "Geri Bildirim Türü",
    "vi_VN": "Loại Phản Hồi",
    "zh_CN": "反馈类型"
  },
  "feedback_cate_fault": {
    "HK": "功能問題",
    "TW": "功能問題",
    "ar_SA": "الخلل/الأخطاء",
    "de_DE": "Bugs/Fehler",
    "en_US": "Bugs/Errors",
    "es_ES": "Errores",
    "fr_FR": "Bugs/erreurs",
    "hi_IN": "Bugs/Errors",
    "in_ID": "Bug/Kesalahan",
    "ja_JP": "他の",
    "ko_KR": "버그/오류",
    "ms_MY": "Pepijat/Ralat",
    "pt_PT": "Bugs/Erros",
    "ru_RU": "Ошибки",
    "th_TH": "Bug/ข้อผิดพลาด",
    "tr_TR": "Açıklar/Hatalar",
    "vi_VN": "Lỗi/Vấn Đề",
    "zh_CN": "功能问题"
  },
  "feedback_cate_other": {
    "HK": "其他",
    "TW": "其他",
    "ar_SA": "غير ذلك",
    "de_DE": "Sonstige",
    "en_US": "Other",
    "es_ES": "Otro",
    "fr_FR": "Autre",
    "hi_IN": "Other",
    "in_ID": "Lainnya",
    "ja_JP": "フィードバックを入力してください。",
    "ko_KR": "다른",
    "ms_MY": "Lain-lain",
    "pt_PT": "Outro",
    "ru_RU": "Другое",
    "th_TH": "อื่นๆ",
    "tr_TR": "Diğer",
    "vi_VN": "Khác",
    "zh_CN": "其他"
  },
  "feedback_cate_product": {
    "HK": "產品建議",
    "TW": "產品建議",
    "ar_SA": "الاقتراحات",
    "de_DE": "Produktvorschläge",
    "en_US": "Product Suggestions",
    "es_ES": "Sugerencias sobre el producto",
    "fr_FR": "Suggestions de produits",
    "hi_IN": "Product Suggestions",
    "in_ID": "Saran",
    "ja_JP": "バグ/エラー",
    "ko_KR": "제품 제안",
    "ms_MY": "Cadangan",
    "pt_PT": "Sugestões de Produto",
    "ru_RU": "Предложения",
    "th_TH": "คำแนะนำ",
    "tr_TR": "Öneriler",
    "vi_VN": "Gợi Ý",
    "zh_CN": "产品建议"
  },
  "feedback_close": {
    "HK": "關閉",
    "TW": "關閉",
    "ar_SA": "قريب",
    "de_DE": "Schließen",
    "en_US": "Close",
    "es_ES": "Cerrar",
    "fr_FR": "Fermer",
    "hi_IN": "Close",
    "in_ID": "Tutup",
    "ja_JP": "フィードバックの種類を選択してください。",
    "ko_KR": "닫다",
    "ms_MY": "Tutup",
    "pt_PT": "Fechar",
    "ru_RU": "Закрыть",
    "th_TH": "ปิด",
    "tr_TR": "Kapat",
    "vi_VN": "Đóng",
    "zh_CN": "关闭"
  },
  "feedback_placeholder": {
    "HK": "請輸入反饋內容",
    "TW": "請輸入回饋內容",
    "ar_SA": "يُرجى إدراج ملاحظاتك",
    "de_DE": "Bitte gib dein Feedback ein.",
    "en_US": "Please enter your feedback.",
    "es_ES": "Escribe tus comentarios.",
    "fr_FR": "Saisissez votre retour.",
    "hi_IN": "Please enter your feedback.",
    "in_ID": "Harap masukkan tanggapan Anda.",
    "ja_JP": "送信",
    "ko_KR": "피드백을 입력하세요.",
    "ms_MY": "Sila masukkan maklum balas anda.",
    "pt_PT": "Por favor, insira seu comentário.",
    "ru_RU": "Оставьте свой отзыв.",
    "th_TH": "กรุณาใส่ฟีดแบ็คของคุณ",
    "tr_TR": "Lütfen geri bildirimini yaz.",
    "vi_VN": "Hãy nhập phản hồi của bạn.",
    "zh_CN": "请输入反馈的内容"
  },
  "feedback_submit": {
    "HK": "提交",
    "TW": "提交",
    "ar_SA": "إرسال",
    "de_DE": "Absenden",
    "en_US": "Submit",
    "es_ES": "Enviar",
    "fr_FR": "Envoyer",
    "hi_IN": "Submit",
    "in_ID": "Kirim",
    "ja_JP": "フィードバック受信",
    "ko_KR": "제출하다",
    "ms_MY": "Serahkan",
    "pt_PT": "Enviar",
    "ru_RU": "Отправить",
    "th_TH": "ส่ง",
    "tr_TR": "Gönder",
    "vi_VN": "Gửi",
    "zh_CN": "提交"
  },
  "feedback_success": {
    "HK": "反饋成功",
    "TW": "回饋成功",
    "ar_SA": "تم استلام الملاحظة",
    "de_DE": "Feedback erhalten",
    "en_US": "Feedback Received",
    "es_ES": "Comentarios recibidos",
    "fr_FR": "Retour reçu",
    "hi_IN": "Feedback Received",
    "in_ID": "Tanggapan Diterima",
    "ja_JP": "提出しました！ ご意見ありがとうございます！",
    "ko_KR": "피드백이 접수 됐습니다",
    "ms_MY": "Maklun Balas Diterima",
    "pt_PT": "Comentário Recebido",
    "ru_RU": "Отзыв получен",
    "th_TH": "ได้รับฟีดแบ็คแล้ว",
    "tr_TR": "Geri Bildirim Alındı",
    "vi_VN": "Đã Nhận Phản Hồi",
    "zh_CN": "反馈成功"
  },
  "feedback_success_content": {
    "HK": "提交成功，感謝你的反饋！",
    "TW": "提交成功，感謝您的回饋！",
    "ar_SA": "تم الارسال! شكرا لملاحظاتك",
    "de_DE": "Gesendet! Danke für dein Feedback!",
    "en_US": "Submitted! Thanks for your feedback!",
    "es_ES": "¡Enviado! ¡Gracias por tus comentarios!",
    "fr_FR": "Envoyé ! Merci pour votre retour !",
    "hi_IN": "Submitted! Thanks for your feedback!",
    "in_ID": "Terkirim! Terima kasih untuk tanggapanmu!",
    "ja_JP": "近い",
    "ko_KR": "제출된! 의견을 보내주셔서 감사합니다!",
    "ms_MY": "Diserahkan! Terima kasih atas maklum balas anda!",
    "pt_PT": "Enviado! Valeu pelo comentário!",
    "ru_RU": "Отзыв отправлен! Спасибо!",
    "th_TH": "ส่งแล้ว! ขอบคุณสำหรับฟีดแบ็ค!",
    "tr_TR": "Gönderildi! Geri bildirimin için teşekkürler!",
    "vi_VN": "Đã gửi! Cảm ơn phản hồi của bạn!",
    "zh_CN": "提交成功，感谢您的反馈！"
  },
  "feedback_tips_cate": {
    "HK": "請選擇反饋類型",
    "TW": "請選擇回饋類型",
    "ar_SA": "يُرجى تحديد نوع الملاحظة",
    "de_DE": "Bitte wähle die Art des Feedbacks aus.",
    "en_US": "Please select the type of feedback.",
    "es_ES": "Selecciona el tipo de comentario.",
    "fr_FR": "Sélectionnez le type de retour.",
    "hi_IN": "Please select the type of feedback.",
    "in_ID": "Pilih jenis tanggapan.",
    "ja_JP": "フィードバックを入力してください。",
    "ko_KR": "피드백 유형을 선택하세요.",
    "ms_MY": "Sila pilih jenis maklum balas.",
    "pt_PT": "Selecione o tipo de comentário.",
    "ru_RU": "Выберите тип отзыва.",
    "th_TH": "กรุณาเลือกประเภทของฟีดแบ็ค",
    "tr_TR": "Lütfen geri bildirim türünü seç.",
    "vi_VN": "Vui lòng chọn loại phản hồi.",
    "zh_CN": "请选择反馈类型"
  },
  "feedback_tips_content": {
    "HK": "請輸入反饋內容",
    "TW": "請輸入回饋內容",
    "ar_SA": "يُرجى إدراج ملاحظاتك.",
    "de_DE": "Bitte gib dein Feedback ein.",
    "en_US": "Please enter your feedback.",
    "es_ES": "Escribe tus comentarios.",
    "fr_FR": "Saisissez votre retour.",
    "hi_IN": "Please enter your feedback.",
    "in_ID": "Masukkan tanggapan.",
    "ja_JP": "スクリーンショットのアップロード (オプション)",
    "ko_KR": "피드백을 입력하세요.",
    "ms_MY": "Sila masukkan maklum balas anda.",
    "pt_PT": "Por favor, insira seu comentário.",
    "ru_RU": "Оставьте свой отзыв.",
    "th_TH": "กรุณาใส่ฟีดแบ็คของคุณ",
    "tr_TR": "Lütfen geri bildirimini yaz.",
    "vi_VN": "Hãy nhập phản hồi của bạn.",
    "zh_CN": "请输入反馈的内容"
  },
  "feedback_title": {
    "HK": "建議反饋",
    "TW": "建議回饋",
    "ar_SA": "‏‏الملاحظات",
    "de_DE": "Feedback",
    "en_US": "Feedback",
    "es_ES": "Comentarios",
    "fr_FR": "Retour",
    "hi_IN": "Feedback",
    "in_ID": "Tanggapan",
    "ja_JP": "フィードバックの種類",
    "ko_KR": "피드백",
    "ms_MY": "Maklum Balas",
    "pt_PT": "Comentários",
    "ru_RU": "Отзывы",
    "th_TH": "ฟีดแบ็ค",
    "tr_TR": "Geri Bildirim",
    "vi_VN": "Phản Hồi",
    "zh_CN": "建议反馈"
  },
  "feedback_upload": {
    "HK": "上傳截圖（選填）",
    "TW": "上傳截圖（選填）",
    "ar_SA": "تحميل لقطة شاشة اختياري",
    "de_DE": "Screenshot hochladen (optional)",
    "en_US": "Upload Screenshot (Optional)",
    "es_ES": "Subir captura de pantalla (opcional)",
    "fr_FR": "Importer une capture d'écran (facultatif)",
    "hi_IN": "Upload Screenshot (Optional)",
    "in_ID": "Unggah tangkapan layar (Opsional)",
    "ja_JP": "内容確認",
    "ko_KR": "스크린샷 업로드(선택 사항)",
    "ms_MY": "Muat Naik Tangkap Skrin (Pilihan)",
    "pt_PT": "Enviar Captura de Tela (Opcional)",
    "ru_RU": "Загрузить скриншот (необязательно)",
    "th_TH": "อัปโหลดภาพสกรีนช็อต (ตัวเลือก)",
    "tr_TR": "Ekran Görüntüsü Yükle (İsteğe Bağlı)",
    "vi_VN": "Tải Lên Ảnh Chụp Màn Hình (Tùy chọn)",
    "zh_CN": "上传截图（选填）"
  }
}